/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CostMultiplierVehicleTypeMultipliersInner from './CostMultiplierVehicleTypeMultipliersInner';

/**
 * The CostMultiplier model module.
 * @module model/CostMultiplier
 * @version 0.0.2
 */
class CostMultiplier {
    /**
     * Constructs a new <code>CostMultiplier</code>.
     * This schema defines a cost multiplier to apply to the base cost metric (duration or distance) to calculate the final travel cost.
     * @alias module:model/CostMultiplier
     * @param vehicleTypeDependence {Boolean} Whether the cost multiplier should depend on the vehicle type. If true, then the cost multiplier will be applied separately for each vehicle type. If false, then the cost multiplier will be applied based on the first vehicle type in the VehicleTypes list.
     */
    constructor(vehicleTypeDependence) { 
        
        CostMultiplier.initialize(this, vehicleTypeDependence);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, vehicleTypeDependence) { 
        obj['vehicleTypeDependence'] = vehicleTypeDependence || false;
        obj['baseMultiplier'] = 1.0;
    }

    /**
     * Constructs a <code>CostMultiplier</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CostMultiplier} obj Optional instance to populate.
     * @return {module:model/CostMultiplier} The populated <code>CostMultiplier</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CostMultiplier();

            if (data.hasOwnProperty('vehicleTypeDependence')) {
                obj['vehicleTypeDependence'] = ApiClient.convertToType(data['vehicleTypeDependence'], 'Boolean');
            }
            if (data.hasOwnProperty('baseMultiplier')) {
                obj['baseMultiplier'] = ApiClient.convertToType(data['baseMultiplier'], 'Number');
            }
            if (data.hasOwnProperty('vehicleTypeMultipliers')) {
                obj['vehicleTypeMultipliers'] = ApiClient.convertToType(data['vehicleTypeMultipliers'], [CostMultiplierVehicleTypeMultipliersInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CostMultiplier</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CostMultiplier</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CostMultiplier.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        if (data['vehicleTypeMultipliers']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['vehicleTypeMultipliers'])) {
                throw new Error("Expected the field `vehicleTypeMultipliers` to be an array in the JSON data but got " + data['vehicleTypeMultipliers']);
            }
            // validate the optional field `vehicleTypeMultipliers` (array)
            for (const item of data['vehicleTypeMultipliers']) {
                CostMultiplierVehicleTypeMultipliersInner.validateJSON(item);
            };
        }

        return true;
    }


}

CostMultiplier.RequiredProperties = ["vehicleTypeDependence"];

/**
 * Whether the cost multiplier should depend on the vehicle type. If true, then the cost multiplier will be applied separately for each vehicle type. If false, then the cost multiplier will be applied based on the first vehicle type in the VehicleTypes list.
 * @member {Boolean} vehicleTypeDependence
 * @default false
 */
CostMultiplier.prototype['vehicleTypeDependence'] = false;

/**
 * The multiplier to apply to the base cost metric (duration or distance) to calculate the final travel cost.
 * @member {Number} baseMultiplier
 * @default 1.0
 */
CostMultiplier.prototype['baseMultiplier'] = 1.0;

/**
 * @member {Array.<module:model/CostMultiplierVehicleTypeMultipliersInner>} vehicleTypeMultipliers
 */
CostMultiplier.prototype['vehicleTypeMultipliers'] = undefined;






export default CostMultiplier;

